import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import ICountry from "@/interfaces/countries/ICountry";
import ICampaignTds from "@/interfaces/ICampaignTds";
import IRelation from "@/interfaces/IRelation";
import ISlug from "@/interfaces/ISlug";
import ITableCol from "@/interfaces/ITableCol";
import ISelectItemDefault from "@/interfaces/selects/ISelectItemDefault";
import transformDateFields from "@/libs/date/transformDateFields";
import getTableColumns from "@/libs/getTableColumns";
import isEmpty from "@/libs/isEmpty";
import {transformMultiSelect} from "@/libs/transformData/transformMultiSelect";
import valueFromStrToObject from "@/libs/valueFromStrToObject";
import Multiselect from 'vue-multiselect';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import Loader from '@/components/Includes/Loader/Loader.vue';
import IPayloadQuery from '@/interfaces/IPayloadQuery';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import {Switch as cSwitch} from '@coreui/vue';

import urlToId from '@/libs/urlToId';
import CampaignTdsCreate from "../CampaignTdsCreate/CampaignTdsCreate.vue";
import CampaignTdsDetail from "../CampaignTdsDetail/CampaignTdsDetail.vue";
import CampaignTdsForm from '../CampaignTdsForm/CampaignTdsForm.vue';

@Component({
    name: 'CampaignTdsList',
    components: {
        Loader,
        CampaignTdsCreate,
        CampaignTdsDetail,
        CampaignTdsForm,
        TableEmpty,
        Multiselect,
        CardHeader,
        cSwitch
    }
})
export default class CampaignTdsList extends Vue {
    @Prop(Number) private campaignId!: number;
    @Prop(Array) private tds!: string[];
    @Prop(Array) private landings!: ISelectItemDefault[];
    @Prop(Array) private countries!: IMultiSelectItem[];
    @Prop(Array) private osForTds!: IMultiSelectItem[];

    // Begin Vuex Logic for Countries
    @Action private subscriptionsCountriesList!: (query: IPayloadQuery) => Promise<void>;
    @Getter private subscriptionsGetCountries!: () => ICountry[];
    // End Vuex Logic for Countries

    // Begin Vuex Logic for Campaign TDS
    @Action private subscriptionsCampaignTdsChange!: (form: ICampaignTds) => string;
    @Action private subscriptionsCampaignTdsRemove!: (id: number) => string;
    @Action private subscriptionsCampaignTdsList!: (query: IPayloadQuery) => number;
    @Action private subscriptionsCampaignTdsDetail!: (id: number) => ICampaignTds;
    @Getter private subscriptionsGetCampaignTdsList!: () => ICampaignTds[];
    // End Vuex Logic for Campaign TDS

    // Begin Vuex Logic for Apple Models
    @Action private subscriptionsAppleModelsList!: () => Promise<void>;
    @Getter private subscriptionsGetAppleModels!: () => ISlug[];
    // End Vuex Logic for Apple Models

    private createTdsForm: boolean = false;
    private detailTdsForm: boolean = false;

    private campaignTds: ICampaignTds[] | null = null;
    private campaignTdsFromCampaign: any = [];

    private selectedCampaignTds: ICampaignTds | null = null;
    private selectedCampaignTdsIndex: number | null = null;


    private showDetailTds(tds: ICampaignTds, index: number) {
        this.detailTdsForm = !this.detailTdsForm;
        this.selectedCampaignTds = tds;
        this.selectedCampaignTdsIndex = index;
    }

    private hideModalDetailTds() {
        this.detailTdsForm = false;
        this.selectedCampaignTds = null;
    }


    private newTds() {
        this.createTdsForm = !this.createTdsForm
    }

    private hideModalCreateTds() {
        this.createTdsForm = false;
    }

    private addTdsItem() {
        this.$emit('reloadCampaign');
        this.campaignTdsFromCampaign = [];
    }

    private deleteTdsItem(tdsIndex: number): void {
        this.campaignTdsFromCampaign.splice(tdsIndex, 1)
    }

    private get tableColumns(): ITableCol[] | undefined {
        return getTableColumns(this.campaignTdsFromCampaign, true, ['campaign', 'id']);
    };

    private get modelsForTds(){
        return transformMultiSelect(this.subscriptionsGetAppleModels(), 'title', 'slug');
    }

    private get countriesForTds() {
        if (isEmpty(this.countries)) {
            return transformMultiSelect(this.subscriptionsGetCountries(), 'name', 'code');
        } else {
            return this.countries;
        }
    }

    private checkDateFields(sourceData: ICampaignTds[]) {
        const dateFields: string[] = ['createdAt', 'updatedAt'];
        sourceData.map(tds => transformDateFields(dateFields, tds))
    }

    // Begin Logic for Landings
    @Watch('campaignTdsFromCampaign')
    @Watch('landings')
    private checkLandings() {
        this.campaignTdsFromCampaign.map((tdsItem: ICampaignTds) => {
            this.landings.filter((el: any) => {
                if (typeof tdsItem.landing === 'object') {
                    tdsItem.landing = el.value === tdsItem.landing.id ? el : tdsItem.landing;
                }
            });
        });
    }

    // End Logic for Landings
    @Watch('tds')
    private async getCampaignTds() {
        const currentCampaignTdsIds = this.tds.map(td => +urlToId(td));
        const tdsRequests = currentCampaignTdsIds.map((id: number) => {
                return this.subscriptionsCampaignTdsDetail(id);
            }
        )
        await Promise.all<ICampaignTds>(tdsRequests)
            .then((data:ICampaignTds[]) => {
                this.campaignTds = data;
                this.campaignTdsFromCampaign = data;
        })
        
        this.checkDateFields(this.campaignTdsFromCampaign);

        valueFromStrToObject('osSet', this.campaignTdsFromCampaign, this.osForTds);
        valueFromStrToObject('modelSet', this.campaignTdsFromCampaign, this.modelsForTds);
        valueFromStrToObject('countrySet', this.campaignTdsFromCampaign, this.countriesForTds);
    }

    private async mounted() {
        const dependencies = [];

        try {
            
            if (isEmpty(this.modelsForTds)) {
                dependencies.push(this.subscriptionsAppleModelsList());
            }

            if (isEmpty(this.countriesForTds)) {
                dependencies.push(this.subscriptionsCountriesList({query: '?pagination=false'}));
            }

            await Promise.all(dependencies);
            await this.getCampaignTds();
        } catch(error) {
           console.error(error);
        }
    }
}
